import { useQuery, useInfiniteQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import {
  listBusinesses,
  listMapBusinesses,
  updateBusiness,
  type BusinessFilter,
  type UpdateBusinessInput,
} from '@/lib/api/businesses';

export function useBusinesses(filter: BusinessFilter) {
  return useInfiniteQuery({
    queryKey: [
      'businesses',
      filter.search ?? '',
      filter.categories?.join(',') ?? '',
      filter.countries?.join(',') ?? '',
    ],
    queryFn: ({ pageParam }) => listBusinesses(filter, pageParam as number),
    initialPageParam: 0,
    getNextPageParam: (lastPage, allPages) =>
      lastPage.hasMore ? allPages.length : undefined,
  });
}

export function useMapBusinesses() {
  return useQuery({
    queryKey: ['businesses-map'],
    queryFn: () => listMapBusinesses(),
  });
}

export function useUpdateBusiness(id: string, slug: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: UpdateBusinessInput) => updateBusiness(id, input),
    onSuccess: (updated) => {
      qc.setQueryData(['business', slug], updated);
      qc.invalidateQueries({ queryKey: ['businesses'] });
      qc.invalidateQueries({ queryKey: ['businesses-map'] });
    },
  });
}
